<div class="with-3-levels box-content">
  <ul class="second-to-last-level">
    @for (secondLevel of node?.children; track secondLevel) {
      @if (secondLevel?.children?.length || secondLevel.url) {
        <li>
          <nav-label [node]="secondLevel" classContainer="label-second-to-last-level"></nav-label>
          <ul class="third-level">
            @for (thirdLevel of secondLevel?.children; track thirdLevel) {
              @if (thirdLevel?.children?.length || thirdLevel.url) {
                <li>
                  <nav-label [node]="thirdLevel" classContainer="label"></nav-label>
                </li>
              }
            }
          </ul>
        </li>
      }
    }
  </ul>

  <div class="box-image" style=" background-image: url('{{ getBaseURL(node.media) }}');"></div>
</div>
